import { render, staticRenderFns } from "./ResourceActivities.vue?vue&type=template&id=dc7b707c&scoped=true&"
import script from "./ResourceActivities.vue?vue&type=script&lang=js&"
export * from "./ResourceActivities.vue?vue&type=script&lang=js&"
import style0 from "./ResourceActivities.vue?vue&type=style&index=0&id=dc7b707c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc7b707c",
  null
  
)

export default component.exports